import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';
import { LearnMoreInlineLink } from 'components/DataDisplay/KnowledgeBase/BaseComponents/LearnMoreInlineLink';
import { renderKnowledgeBaseList } from 'components/DataDisplay/KnowledgeBase/utils';

export const LearnMoreAboutRemediation: FC = () => {
  const links: KnowledgeBaseLink[] = [
    { label: 'Findings', field: 'findings' },
    { label: 'Issues', field: 'issues' },
    { label: 'Ticketing', field: 'ticketing' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="remediation"
      headerTitle="Remediation"
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Description</Text>
            <Text>
              Ariksa provides turnkey library of remediation commands that can
              be used to quickly fix common issues including misconfigurations
              or combinations of toxic configurations. One or more remediation
              steps are associated with individual issues. This enables rapid
              multi-step response to completely fix an{' '}
              <LearnMoreInlineLink label="issue" field="issues" value />.
            </Text>
            <Text pt={2}>
              In addition to out-of-the-box remediation steps, you can also
              create custom remediation steps. Each custom remediation step
              needs to be associated with a corresponding policy violation for
              it to be available for response – manual or automatic. There is no
              numerical restriction on the number of remediations that are
              associated with a given policy. All remediations, custom and
              standard, can be executed from Ariksa manually or automatically.
            </Text>
          </Stack>
          <Stack>
            <Text fontWeight={600} pb={2}>
              Custom Remediation
            </Text>
            <Text>
              You can create and use custom remediation from Policy Hub /
              Remediation
            </Text>
            {renderKnowledgeBaseList([
              'Choose a resource type',
              'Pick the cloud-native command to execute',
              'Ariksa automatically indicates the mandatory fields',
              'Choose any optional fields that you require',
              'Associate the remediation option with one or more policies to enforce',
            ])}
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
